import { SOCIALS_2 } from "componentsTemplate/SocialsList/SocialsList";
import { SocialType } from "componentsTemplate/SocialsShare/SocialsShare";
import React, { FC, useEffect, useState } from "react";
import { toast } from "react-toastify";
import { getSocialMedia } from "services/PageService";

export interface SocialsList1Props {
  className?: string;
}

const socials: SocialType[] = SOCIALS_2;

const SocialsList1: FC<SocialsList1Props> = ({ className = "space-y-2.5" }) => {

  const [socialMedia, setSocialMedia] = useState<any>([]);

  const fetchInstitutional = async () => {
    try {
      const data = await getSocialMedia();
     
      setSocialMedia(data);
    } catch (error) {
      // toast.error("Erro ao carregar os dados");
    }
  };

  useEffect(() => {
    fetchInstitutional();
  }, []);


  const renderItem = (item: any, index: number) => {
    return (
      <a
        target="blank"
        href={item.link}
        className="flex items-center text-2xl text-neutral-100 hover:text-white dark:text-neutral-300 dark:hover:text-white leading-none space-x-3 "
        key={index}
      >
        <div dangerouslySetInnerHTML={{ __html: item.icon || "" }}></div>
        <span className="hidden lg:block text-sm">{item.name}</span>
      </a>
    );
  };

  return (
    <div className={`nc-SocialsList1 ${className}`} data-nc-id="SocialsList1">
      {/* {socials.map(renderItem)} */}
      {socialMedia.map(renderItem)}
    </div>
  );
};

export default SocialsList1;
